import axios from "axios";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useAccount } from "../Account";
import { useGlobalConfig } from "../GlobalConfig";
import {
  clearAccountData,
  clearSearchHistory,
} from "../../util/clearSensitiveSessionData";

export const LogoutPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAccount();
  const { adfsSettings } = useGlobalConfig();

  React.useEffect(() => {
    if (adfsSettings.enabled && user.local === false) {
      window.location.href = adfsSettings.logoutUrl;
      return;
    }

    axios.get(`/logout`).then(() => {
      clearAccountData();
      clearSearchHistory();
      navigate("/"); // redirect to home
    });
  }, []);

  return <></>;
};
